import * as React from 'react';
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Element, scroller} from "react-scroll";
import {Alert} from '@material-ui/lab';

interface IProps {
    heading?: string;
    referenceIdentifierToken?: any;
}

function scrollToTopOfResults() {
    scroller.scrollTo("customer-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class ExpeditedEnrollmentResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                {this.props.referenceIdentifierToken &&
                    <h4>{this.props.heading}</h4>}
                <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>


                    {this.props.referenceIdentifierToken &&
                        <Alert variant="filled" severity="info">
                            Please replace "token-generated" with "referenceIdentifierToken" in URL "https://pharmacy.integ.amazon.com/enroll/signup/person-account/picker?referenceIdentifierToken=token-generated"
                        </Alert>}

                    <Element name="customer-result"/>
                    {this.props.referenceIdentifierToken && scrollToTopOfResults()}
                    <JsonRenderComponent jsonObject={this.props.referenceIdentifierToken} printHtml={false}/>
                </p>
            </div>
        );
    }

}

export default ExpeditedEnrollmentResult;
